<template>
  <div>
    <h-loading v-if="isMissionLoading" />

    <div v-if="!isMissionLoading && data">
      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.name') }}
          </h6>
          <span class="body-2">
            {{ data.name }}
          </span>
        </v-col>
        <v-col cols="3">
          <h6 class="text-uppercase grey--text text-center">
            {{ $t(`mission.status.${data.active}`) }}
          </h6>
          <span class="d-block body-2 text-center">
            <IconIsActive :is-active="data.active" :subtitle="$t(`mission.status.${data.active}`)" />
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.createdBy') }}
          </h6>
          <p class="body-2 mb-0">
            {{ creator ? creator : '---' }}
            <span class="caption d-block grey--text">
              {{ creatorsEmail ? creatorsEmail : '---' }}
            </span>
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.description') }}
          </h6>
          <span class="body-2">
            {{ data.description }}
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.price') }}
          </h6>
          <span class="body-2">
            {{ formatMoney(data.price) }}
          </span>
        </v-col>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.serviceQuantity') }}
          </h6>
          <span class="body-2">
            {{ data.service_quantity }}
          </span>
        </v-col>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.tierHost') }}
          </h6>
          <span class="body-2">
            {{ data.tier_host }}
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.startDate') }}
          </h6>
          <span class="body-2">
            {{ formatDate(data.start_date) }}
          </span>
        </v-col>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.endDate') }}
          </h6>
          <span class="body-2">
            {{ formatDate(data.end_date) }}
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.missionDay') }}
          </h6>
          <span
            v-for="day in data.mission_day"
            :key="day"
            class="separated-by-dash body-2"
          >
            {{ $t(`week.${day}`) }}
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.serviceTypes') }}
          </h6>
          <div
            v-for="type in data.service_types"
            :key="type"
            class="d-flex align-center mt-1"
          >
            <div class="mw-25 mr-2" v-html="handleGetIcon(type)" />
            <span class="d-block body-2 pb-2">
              {{ $t(`appointment.type.${type}`) }}
            </span>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mission.label.cities') }}
          </h6>
          <div v-for="city in data.cities" :key="city.name">
            <CityName :name="city.name" />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text mb-2">
            {{ $t('mission.label.hosts') }}
          </h6>
          <span v-if="hasAllowedHosts">
            <div v-for="host in data.allowed_hosts" :key="host.id">
              <p class="body-2 mb-2">
                {{ host.name }}
                <span class="d-block caption grey--text">
                  {{ host.username }}
                </span>
              </p>
            </div>
          </span>
          <span v-else class="caption"> --- </span>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { icons } from '@/util/iconsSVG'
import { catalogDate, catalogMonetary } from '@/util/catalog'

import CityName from '@/components/city/CityName'
import IconIsActive from '@/components/IconIsActive'

export default {
  name:"MissionSummary",

  props: {
    data: {
      required: true
    }
  },

  components: {
    CityName,
    IconIsActive
  },

  computed: {
    ...mapGetters(['isMissionLoading']),

    hasAllowedHosts() {
      if (!this.data?.allowed_hosts) return
      return this.data.allowed_hosts.length >= 1
    },

    creator() {
      if (!this.data) return
      return this.data?.created_by?.name
    },

    creatorsEmail() {
      if (!this.data) return
      return this.data?.created_by?.username
    }
  },

  methods: {
    formatDate(date) {
      return catalogDate(date)
    },

    formatMoney(price) {
      return price ? catalogMonetary(price) : '---'
    },

    handleGetIcon(type) {
      return icons[type]
    },
  },
}
</script>
